import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const SESSION_KEY = 'maple_session_id';

const getSessionId = () => {
  let sid = sessionStorage.getItem(SESSION_KEY);
  if (!sid) {
    sid = 'ses_' + Math.random().toString(36).substring(2) + Date.now().toString(36);
    sessionStorage.setItem(SESSION_KEY, sid);
  }
  return sid;
};

const PageTracker = () => {
  const location = useLocation();
  const lastTracked = useRef('');

  useEffect(() => {
    const key = location.pathname + location.search;
    if (key === lastTracked.current) return;
    lastTracked.current = key;

    const data = {
      page: location.pathname,
      referrer: document.referrer || '',
      sessionId: getSessionId()
    };

    // Don't track admin pages
    if (location.pathname.startsWith('/admin')) return;

    fetch('/api/analytics/track', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    }).catch(() => {});
  }, [location]);

  return null;
};

export default PageTracker;
